export default [
  {
    path: '/pemrek-aladin-verify',
    name: 'pemrek-aladin-verify',
    component: () => import('@/views/pemrek-aladin-verify/index.vue'),
    props: true,
    meta: {
      pageTitle: 'Bukti Pemrek Aladin',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Aladin',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pemrek-aladin-verify/add',
    name: 'pemrek-aladin-verify-add',
    component: () => import('@/views/pemrek-aladin-verify/create/index.vue'),
    meta: {
      pageTitle: 'Bukti Pemrek Baru',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Aladin',
          to: '/pemrek-aladin-verify'
        },
        {
          text: 'Bukti Pemrek Baru',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pemrek-aladin-verify/detail',
    name: 'pemrek-aladin-verify-detail',
    component: () => import('@/views/pemrek-aladin-verify/detail/index.vue'),
    meta: {
      pageTitle: 'Bukti Pemrek Baru',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Aladin',
          to: '/pemrek-aladin-verify'
        },
        {
          text: 'Bukti Pemrek Aladin',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pemrek-aladin-activation/add',
    name: 'pemrek-aladin-activation-add',
    component: () => import('@/views/pemrek-aladin-activation/create/index.vue'),
    meta: {
      pageTitle: 'Bukti Pemrek Baru',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Aladin',
          to: '/pemrek-aladin-verify'
        },
        {
          text: 'Bukti Aktivasi',
          active: true,
        },
      ],
    },
  },
]